import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useCallback, useState } from "react";
// @ts-expect-error - TS7016 - Could not find a declaration file for module 'uuid/v4'. '/Users/dkrajnak/workspace/aviso/sse-frontend/react/node_modules/uuid/v4.js' implicitly has an 'any' type.
import * as uuid from "uuid/v4";
import SecondaryNavButton from "../UI/SecondaryNav/SecondaryNavButton";
import MessageAttachmentButton from "../Container/Message/MessageAttachment/MessageAttachmentButton";
import { AlertError } from "../UI/StandardAlerts/StandardAlerts";
import FAIcon from "../UI/FAIcon/FAIcon";
import AttachmentService from "../../Services/Attachment.service";
import Attachment from "../Presentational/Attachment/Attachment";
const defaultOptions = {
    initialAttachments: [],
};
/**
 * @deprecated use AttachmentsField.
 */
const useAttachments = (_options = defaultOptions) => {
    const options = React.useMemo(() => (Object.assign(Object.assign({}, defaultOptions), _options)), [_options]);
    const [draftId, setDraftId] = useState(uuid());
    const [attachmentError, setAttachmentError] = useState(null);
    const [attachments, setAttachments] = useState(options.initialAttachments);
    // Track files being uploaded (for loading display)
    const [filesBeingUploaded, setFilesBeingUploaded] = useState([]);
    const attachmentsSize = React.useMemo(() => attachments.reduce((sum, att) => att.size + sum, 0), [attachments]);
    // @ts-expect-error - TS7006 - Parameter 'attachmentId' implicitly has an 'any' type.
    const onAttachmentRemove = useCallback((attachmentId) => setAttachments((currentAttachments) => currentAttachments.filter((currentAttachment) => currentAttachment.attachmentId !== attachmentId)), []);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const attachmentButton = (_jsx(MessageAttachmentButton, { button: _jsx(SecondaryNavButton, { icon: "paperclip", label: "Attach", title: "Attach files to message", type: "button" }), totalSize: attachmentsSize, existingFilesCount: 0, onChange: (files) => {
            // Direct upload like NewMessageModal instead of using batch system
            if (files.length > 0) {
                // Immediately show files in loading state
                setFilesBeingUploaded((current) => [...current, ...files]);
                setAttachmentError(null); // Clear any previous errors
                AttachmentService.uploadFiles(files, draftId)
                    .then((uploadedAttachments) => {
                    // Clear all loading files (simpler and more reliable)
                    setFilesBeingUploaded([]);
                    // Add to uploaded attachments
                    setAttachments((currentAttachments) => [
                        ...currentAttachments,
                        ...uploadedAttachments,
                    ]);
                })
                    .catch((error) => {
                    // Clear all loading files on error
                    setFilesBeingUploaded([]);
                    setAttachmentError("Unable to upload file(s). The file(s) may not be supported or may have failed security validation.");
                });
            }
        }, onError: (error) => {
            setAttachmentError(error);
        } }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const attachmentsComponent = (_jsxs(_Fragment, { children: [_jsxs("div", { className: "d-flex flex-wrap", children: [filesBeingUploaded.map((file, index) => (_jsx(Attachment, { attachment: file, className: "mb-3 mr-3", isLoading: true }, `loading-${index}`))), attachments.map((attachment, index) => (_jsx(Attachment, { attachment: attachment, className: "mb-3 mr-3", removeAttachment: () => {
                            onAttachmentRemove(attachment.attachmentId);
                        } }, attachment.attachmentId)))] }), attachmentError && _jsx(AlertError, { message: attachmentError })] }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const warningText = (_jsxs("small", { className: "form-text mb-3", children: [_jsx(FAIcon, { icon: "info-circle", addMarginRight: true }), "Recipients must log into SS&E to download attachments. A link will be shown at the bottom of the message so that recipients will be able to quickly login and download attachments."] }));
    const resetAttachments = useCallback(() => {
        setAttachmentError(null);
        setAttachments([]);
        setFilesBeingUploaded([]);
        setDraftId(uuid());
    }, []);
    return React.useMemo(() => ({
        attachments,
        attachmentButton,
        attachmentsComponent,
        warningText,
        resetAttachments,
        onAttachmentRemove,
        draftId,
    }), [
        attachmentButton,
        attachments,
        attachmentsComponent,
        draftId,
        resetAttachments,
        warningText,
        onAttachmentRemove,
    ]);
};
export default useAttachments;
